import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const SortPage: React.FC = () => {
 return (
    <div className={styles.container}>
      <h1 className={styles.title}>Sorting </h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title='Quick Sort'
          description='Divides and conquers data for fast average sorting performance.'
          link ='/sort/quick'
          icon='⚡️'
          />
        <TopicCard
          title='Bubble Sort'
          description='Swaps adjacent elements repeatedly until the list is sorted.'
          link ='/sort/bubble'
          icon='⚪'
          />
        <TopicCard
          title='Merge Sort'
          description='Splits and merges lists efficiently for consistent results.'
          link ='/sort/merge'
          icon='🔀'
          />
        <TopicCard
          title='Compare Sort'
          description='See Bubble, Quick, and Merge sort compete side by side.'
          link ='/sort/compare'
          icon='🏁'
          />
      </div>
    </div>
  );
};

export default SortPage;